import { Button } from 'react-bootstrap'
import styled from 'styled-components'
import { Card } from '../../../components'
import { colors } from '../../../const/theme'

export const CardWrapper = styled(Card)`
  width: 45%;
  padding: 0 32px 16px;
  @media (max-width: 415px) {
    width: 100%;
    margin-bottom: 16px;
  }
`
export const LeaveActionWrapper = styled.div`
  display: flex;
  justify-content: center;
`
export const Icon = styled(Button)`
  border-color: ${colors.white};
  color: ${colors.gray};
  text-transform: capitalize;
  &:hover,
  &:focus {
    border-color: ${colors.white};
    background: ${colors.white};
    color: ${colors.black};
  }
  max-width: 40px;
`
